(function (ws) {
    'use strict';
    ws.views.logout = ws.views.googleAnalytics.extend({
        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'user',
        GTM_LOGOUT_EVENT_ACTION: 'logout',

        /**
         * The ID of the modal to open.
         *
         * @const {string}
         */
        MODAL_ID: 'openLogoutConfirmation',

        /**
         * Initialize
         */
        initialize() {
            _.bindAll(this, 'continueLogout');

            this.$link = this.$el.find('a');

            this.$link.on('click', this.openLogoutConfirm.bind(this));
            this.eventAgg.on(this.MODAL_ID + 'continue', this.continueLogout, this);

            ws.views.googleAnalytics.prototype.initialize.call(this);
        },

        /**
         * open Logout confirmation modal
         * @param {Object} e
         */
        openLogoutConfirm(e) {
            e.preventDefault();
            this.eventAgg.trigger(this.MODAL_ID);
        },

        /**
         * redirect to logout URL on confirmation
         */
        continueLogout() {
            // No tracking on order entry site
            if (!isOrderEntrySite) {
                this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_LOGOUT_EVENT_ACTION, this.GTM_EVENT_LABEL);
                _satellite.track('event:user:logout');
            }

            $.get($('#ssoLogOut').val(), (resp) => {
                console.log('response from server', resp);
            }).fail(()=> {
                console.log('something went wrong!');
            });

            window.location.href = this.$link.data('link') ? this.$link.data('link') : this.$link.attr('href');
        }
    });
})(westcon);
